import React, { Component } from 'react';
import './App.scss';
import Navbar from './components/layout/Navbar/index';
import Products from './components/layout/Products/index';
import CartContainer from './components/layout/Cart/CartContainer/index';
import CheckoutContainer from './components/layout/Checkout/CheckoutContainer/index';

class App extends Component {
  componentDidMount() {
    const checkout = document.getElementById('checkout');
    checkout.style.display = 'none';
  }

  render() {
    return (
      <div className='App'>
        <Navbar />
        <div className='ui-window' id='ui-window'>
          <CartContainer />
          <Products />
        </div>
        <CheckoutContainer />
        <div>
          <footer>
            Icons by{' '}
            <a href='https://www.flaticon.com/authors/freepik' title='Freepik'>
              Freepik
            </a>{' '}
            from{' '}
            <a href='https://www.flaticon.com/' title='Flaticon'>
              www.flaticon.com
            </a>
          </footer>
        </div>
      </div>
    );
  }
}

export default App;
